module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/main-visual_winter-2e1208b953184d15b40d69f7b405614d.webp";